import React, { useEffect, useState } from "react";
import "./Header.scss";

export default function Header({ isAluno = false }) {
  const [nome, setNome] = useState("");
  const [dataAtual, setDataAtual] = useState("");
  const [saudacao, setSaudacao] = useState("");

  useEffect(() => {
    const usuario = JSON.parse(localStorage.getItem("usuario"));
    if (usuario && usuario.nome) {
      const primeiroNome = usuario.nome.split(" ")[0];
      setNome(primeiroNome);
    }

    const hora = new Date().getHours();
    if (hora < 12) setSaudacao("Bom dia");
    else if (hora < 18) setSaudacao("Boa tarde");
    else setSaudacao("Boa noite");

    const hoje = new Date();
    const dataFormatada = hoje.toLocaleDateString("pt-BR", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    const dataComCapital =
      dataFormatada.charAt(0).toUpperCase() + dataFormatada.slice(1);
    setDataAtual(dataComCapital);
  }, []);

  return (
    <header className={`header-container ${isAluno ? "is-aluno" : ""}`}>
      <div className="left-content">
        <span className="text-saudacao">
          {saudacao}, {nome}! <span className="emoji">👋</span>
        </span>
      </div>

      <div className="right-content">
        <span className="data-text">{dataAtual}</span>
      </div>
    </header>
  );
}
